<template>
  <div class="mainPage">
    <p id="headPage">VOUCER</p>
    <div class="cardRow">
      <!-- <div id="titleRow"> </div> -->
      <div class="inRow">
        <div class="card" id="startBalance">
          <p id="titleCard">Saldo Awal</p>
          <p id="amountCard">{{formatUang(totalBalance.startBalance)}}</p>
        </div>
        <div class="card" id="inCard">
          <p id="titleCard">Kas Masuk</p>
          <p id="amountCard">{{formatUang(totalBalance.addDebt)}}</p>
        </div>
        <div class="card" id="outCard">
          <p id="titleCard">Kas Keluar</p>
          <p id="amountCard">{{formatUang(totalBalance.payDebt)}}</p>
        </div>
        <div class="card" id="balanceCard">
          <p id="titleCard">Saldo Akhir</p>
          <p id="amountCard">{{formatUang(totalBalance.endBalance)}}</p>
        </div>
      </div>
    </div>
    <div class="filterRow">
      <div id="titleRow"></div>
      <div class="inRow">
        
      </div>
      <div class="inRow">
        <div class="inCol" id="cardFilter">
          
          <p id="inputTitle" >Tanggal Mulai</p>
          <b-input type="date"  v-model="startDate"  @change="this.getVoucer"></b-input>
        </div>
        <div class="inCol" id="cardFilter">
          <p id="inputTitle">Tanggal Selesai</p>
          <b-input type="date" v-model="endDate"  @change="this.getVoucer"></b-input>
        </div>
        <div class="inCol"  id="cardFilter">
          <p id="inputTitle">Jenis Voucer</p>
          <b-select v-model="findType" @change="this.getVoucer">
            <option :value=1> Pemasukan </option>
            <option :value=2> Pengeluaran </option>
          </b-select>
        </div>
        <div class="inCol"  id="cardFilter">
          <p id="inputTitle">Nomor Rumah</p>
          <b-select v-model="findHomeId" @change="this.getVoucer">
            <option v-for="e in this.homes" :key="e.id" :value="e.id">{{ e.name }}</option>
          </b-select>
        </div>
        <div class="inCol" id="cardFilter">
          <p id="inputTitle">Keyword</p>
          <b-input type="text" v-model="keyword"  @change="this.getVoucer"></b-input>
        </div>

      </div>
    </div>
    <div id="titleRow">
      <b-button id="addModal" @click.prevent="showAdd()">Tambah</b-button>
      <b-button id="resetFilter" @click.prevent="resetFilter()">Reset Filter</b-button>
      <button @click.prevent="printCsv()" id="printer">
          <img src="../assets/printer.png" id="printer" alt="">
      </button>
    </div>
    <div class="pagination mt-2">
        <button type="button" class="mr-1" id="pageButton" v-if="currentPage > 1"  @click.prevent="minPage()"> &lt; </button>
        <button class="mr-1" id="pageButton" v-if="currentPage <= 1"  > &lt; </button>
        <p class="mr-1"> {{this.currentPage}} </p>
        <p class="mr-1">/</p> 
        <p class="mr-1">{{this.totalPage}} </p> 
        <button type="button" id="pageButton" v-if="this.currentPage < this.totalPage" @click.prevent="addPage()"> > </button>
        <button id="pageButton" v-if="this.currentPage >= this.totalPage" > > </button>
      </div>
    <div class="tableRow">
      <div class="inRow">
        <lord-icon
          v-if="this.isLoading"
          src="https://cdn.lordicon.com/dpinvufc.json"
          trigger="loop"
          style="width:300px;height:300px">
        </lord-icon>
      </div>
      
      <table v-if="!isLoading" class="table-bordered table-hover" id="tableData">
        <thead>
          <tr>
            <th>#</th>
            <th>Tanggal</th>
            <th>No.Reff</th>
            <th>Jenis</th>
            <th>Akun</th>
            <th>NDR</th>
            <th>Keterangan</th>
            <th>Jumlah</th>
            <th colspan="4">Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(e,index) in this.voucers" :key="e.id">
            <td>{{ index+1 }}</td>
            <td>{{formatDate(e.date)}} </td>
            <td> {{e.refNo}} </td>
            <td v-if="e.type == 1" class="text-center"> <img id="status" src="../assets/masuk.png" alt=""> </td>
            <td v-if="e.type == 2" class="text-center"> <img id="status" src="../assets/keluar.png" alt=""> </td>
            <!-- <td> {{ cekMak(e.MatataAnggaranId) }} </td> -->
            <td>{{ e.MataAnggaran.name }}</td>
            <td>{{ cekHome(e.HomeId) }}</td>
            <td> {{e.notes}}  <img v-if="e.isEdit" id="edited" src="../assets/edited.png" alt=""> </td>
            <td class="uang"> {{ formatUang(e.amount)}} </td>
            <td id="action" class="text-center" v-if="role == 'cashier'">
                <button @click.prevent="setPrintData(e)" title="Print" >
                  <img src="../assets/printer.png" alt="">
                </button>
              </td>
              <!-- <td id="action" class="text-center" >
                <button @click.prevent="changeStatus(e)" title="Print" >
                  <img v-if="e.isOpen" src="../assets/gembokGreen.png" alt="">
                  <img v-if="!e.isOpen" src="../assets/gembokRed.png" alt="">
                </button>
              </td> -->
              <!-- <td v-if="e.isEdit == 1" class="text-center"> <img id="edited" src="../assets/edited.png" alt=""> </td> -->
              <!-- <td id="action" class="text-center" >
                <button @click.prevent="changeStatus(e.id)" title="Ubah Status Open" >
                  <lord-icon
                    src="https://cdn.lordicon.com/wloilxuq.json"
                    trigger="hover">
                  </lord-icon>
                </button>
            </td> -->
            <td id="action" class="text-center" >
              <button @click.prevent="showEdit(e)" title="Edit" >
                <img src="../assets/edit.png" alt="">
              </button>
            </td>
            <td id="action" class="text-center" >
              <button @click.prevent="confirmDelete(e.id)" title="Hapus">
                <img src="../assets/trash.png" alt="">
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="pagination mt-2">
        <button type="button" class="mr-1" id="pageButton" v-if="currentPage > 1"  @click.prevent="minPage()"> &lt; </button>
        <button class="mr-1" id="pageButton" v-if="currentPage <= 1"  > &lt; </button>
        <p class="mr-1"> {{this.currentPage}} </p>
        <p class="mr-1">/</p>
        <p class="mr-1">{{this.totalPage}} </p> 
        <button type="button" id="pageButton" v-if="this.currentPage < this.totalPage" @click.prevent="addPage()"> > </button>
        <button id="pageButton" v-if="this.currentPage >= this.totalPage" > > </button>
      </div>
    </div>

    <!-- modal -->
  <div class="modal" id="mainModal">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Voucer</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" >&times; </span>
        </button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="isEdit ? editVoucer() : addVoucer()">
          <div class="inRow">
            <div class="inCol">
              <p id="titleModal">Tanggal</p>
              <b-input v-model="date" type="date" required></b-input>
            </div>
            <div class="inCol">
              <p id="titleModal">Jenis Voucer</p>
              <b-select v-model="type" @change="this.setMak" required>
                <option value="1">Pemasukan</option>
                <option value="2">Pengeluaran</option>
              </b-select>
            </div>
            <div class="inCol">
              <p id="titleModal">Akun</p>
              <!-- <b-select v-model="secondMak" required>
                <option v-for="e in this.maks" :key="e.id" :value="e.id">{{ e.name }}</option>
              </b-select> -->
              <b-form-input list="my-list-id" @input="setMak($event)"></b-form-input>
              <datalist id="my-list-id">
                <option v-for="e in this.maks" :key="e.id" :value="e.name">{{ e.name }}</option>
              </datalist>
            </div>
            <div class="inCol">
              <p id="titleModal">Jumlah</p>
              <b-input class="text-right" v-model="amount" type="text" @input="currencyNumber($event)"  required></b-input>
            </div>
            <div class="inCol">
              <p id="titleModal">NDR Rumah</p>
              <b-select v-model="HomeId" >
                <option v-for="e in this.homes" :key="e.id" :value="e.id">{{ e.name }}</option>
              </b-select>
            </div>
          </div>
          <div class="inRow">
          </div>
          <div class="inRow">
            <div class="inCol">
              <p id="titleModal">Keterangan</p>
              <b-input v-model="notes" name="detail" type="text" required></b-input>
            </div>
          </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="submit" class="btn btn-primary">Tambah</button>
        </div>
      </form>
      </div>
    </div>
  </div>
<!-- Print -->
  <div id="printArea">

    <div class="headPrint">
      <p id="titlePrint" v-if="this.print.type == 1">Voucer Penerimaan</p>
      <p id="titlePrint" v-if="this.print.type == 2">Voucer Pengeluaran</p>
      <p id="brancName"> {{ print.branchName }} </p>
      <p id="datePrint"> {{ print.date }} </p>
    </div>
    <hr>
    <div class="mainPrint">
      <table class="table table-borderless" id="printTable">
          <tr>
            <td id="keyTable">Nomor</td>
            <td id="titikDua">:</td>
            <td>{{ print.nomor }}</td>
          </tr>
          <tr>
            <td id="keyTable">Jumlah</td>
            <td id="titikDua">:</td>
            <td>Rp.{{ print.amount }}</td>
          </tr>
          <tr>
            <td id="keyTable">Keterangan</td>
            <td id="titikDua">:</td>
            <td>{{ print.notes }}</td>
          </tr>
      </table>
      <hr>
    </div>
    <div class="signArea">
      <div class="inRow">
        <div class="inCol">
          <p id="name">Kasir</p>
          <p>(............................)</p>
        </div>
        <div class="inCol" v-if="this.print.type == 1">
          <p id="name">Pemberi</p>
          <p>(............................)</p>
        </div>
        <div class="inCol" v-if="this.print.type == 2">
          <p id="name">Penerima</p>
          <p>(............................)</p>
        </div>
        <div class="inCol">
          <p id="name">Akuntansi</p>
          <p>(............................)</p>
        </div>
        <div class="inCol">
          <p id="name">Direktur</p>
          <p>(............................)</p>
        </div>
      </div>
    </div>
    <hr>
  </div>
</div>
</template>

<script>
import axios  from '../API/axios'
import Swal from "sweetalert2";
import moment from 'moment'
import csvDownload from 'json-to-csv-export'
import html2pdf from "html2pdf.js";
export default {
  name: "Voucer",
  data() {
    return  {
      id: 0,
      voucers: [],
      currentPage: 1,
      perPage: 40,
			totalPage : 1,
      isLoading: false,
      isEdit: false,
      totalBalance: {},
      KelompokMaId: 0,
      maks: [],
      homes:[],
      // filter
      startDate: "",
      endDate: "",
      keyword: "",
      findType: '',
      findHomeId: 0,
      // modal
      BranchId: 0,
      amount: '',
      notes: "",
      status: 1,
      date: "",
      type: "",
      secondMak: 0,
      HomeId: 0,

      // print
      print: {
        branchName: '',
        date: '',
        nomor: '',
        notes: '',
        amount: '',
        type: 0
      }

    }
  },
  created() {
    console.log(this.maks,"---------------");
    // this.$store.dispatch("getBranch")
    this.getVoucer()
    this.getHome()
    
  },
  computed: {
    role() {
      return localStorage.getItem("role");
    },
    types() {
      return this.$store.state.types
    },
  },  
  methods: {
    resetFilter() {
      this.findBranchId= 0
      this.findType= ""
      this.findStatus= ""
      this.startDate= ""
      this.endDate= ""
      this.currentPage= 1
      this.getVoucer()
    },
    showAdd() {
      // return alert("Yess")
      this.isEdit = false
      this.date = moment(new Date).format("YYYY-MM-DD")
      $('#mainModal').modal('show')
    },

    setPrintData(e) {
      this.print.branchName = e.Branch.branchName,
      this.print.date = moment(e.date).format('DD-MM-YYYY')
      this.print.nomor = e.refNo
      this.print.amount = this.formatUang(e.amount)
      this.print.notes = e.notes
      this.print.type = e.type
      this.exportToPDF()
    },

    exportToPDF() {
      this.isLoading = true
      document.getElementById('printArea').style.display='block'
      html2pdf(document.getElementById('printArea'),  {
        margin: 1,
        filename: "Voucer.pdf",
      }).then(e => {
        document.getElementById('printArea').style.display='none'
        this.isLoading = false
      })
    },
    async setMak(e) {
      // console.log(e,"--------");
      let {data} = await axios({
        method: "GET",
        url: "/transaksi/mak",
        headers: {
          access_token: localStorage.getItem("access_token")
        },
        params: {
          type: this.type,
          name: e,
        }
      })
      this.maks = data
      let avaliableOptions = this.maks.map(x => x.name)
      if(!avaliableOptions.includes(e)) {
        this.secondMak = 0
        return
      }
      let id = this.maks.find(x => x.name == e).id
      this.secondMak = id
    },
    setMak2(e) {
      let avaliableOptions = this.maks.map(x => x.name)
      if(!avaliableOptions.includes(e)) {
        this.secondMak = 0
        return
      }
      let id = this.maks.find(x => x.name == e).id
      this.secondMak = id
    },
    async getmaks() {
      // try {
      //   this.secondMak = 0
      //   let {data} = await axios({
      //     method: "GET",
      //     url: "/transaksi/mak",
      //     headers: {
      //       access_token: localStorage.getItem("access_token")
      //     },
      //     params: {type: this.type}
      //   })
      //   this.maks = data
      // } catch(err) {
      //   console.log(err);
      // }
    },
    showEdit(e) {
      this.id = e.id
      this.isEdit = true
      $('#mainModal').modal('show')
      this.BranchId=  e.BranchId,
      // OrderId=  e.OrderId,
      this.date=  e.date,
      this.status=  e.status,
      this.type=  e.type,
      this.notes=  e.notes,
      this.amount=  this.setEditAmount(e.amount)
    },

    currencyNumber(event, target) {
        console.log(event, "===================");
        let currentValue = event.trim().split('.').filter(e => e != '.' ).join('')

        console.log(currentValue, typeof currentValue," -----------");
        if( Number.isNaN(Number(currentValue))) {
          // this.amount = 10
          this.amount = this.formatUang(currentValue.split('').filter(e => !Number.isNaN( Number(e))).join(''))
          return
        }
        // currentValue = this.amount
        this.amount = this.formatUang(currentValue)
        // currentValue = this.amount
        // this.amount = this.amount.toLocaleString('id-ID')
        console.log(this.amount, "++++++++++++++");
    },
    setEditAmount(currentValue) {
      let result = 0
      if( Number.isNaN(Number(currentValue))) {
          // this.amount = 10
          this.amount = this.formatUang(currentValue.split('').filter(e => !Number.isNaN( Number(e))).join(''))
          return
        }
        // currentValue = this.amount
      result = this.formatUang(currentValue)
      return result 
    },


    async changeStatus(e) {
      
      try {
        if(e.status == 2 && e.amount > 2000000) return  Swal.fire('Maaf', 'data anda tidak dapat diubah', 'error');
        let data2 = await axios({
          method: "patch",
          url: `/transaksi/isopen/${e.id}`,
          headers: {
            access_token: localStorage.getItem("access_token")
          },
        })
        Swal.fire('Berhasil', 'Data berhasil diproses', 'success');
        this.getVoucer()
      } catch(err) {
        console.log(err);
        Swal.fire('Maaf', 'Periksa Kembali data anda', 'error');
      }
    },
    formatDate(date) {
      let result = ''
      if(date) return moment(date).format("DD-MM-YYYY")
    },

    formatUang(data) {
      // console.log(data);
        
      let uang = "";
        if(data) {
          data = data.toString();
          for (let i = 0; i < data.length; i++) {
            if ((data.length - i) % 3 == 0 && i !== 0) {
            uang += `.${data[i]}`;
            } else {
            uang += data[i];
            }
          }
        }
        return uang
    },
    async getVoucer() {
      this.isLoading = true
      try {
        
        let {data} = await axios({
          method: "GET",
          url: "/transaksi",
          headers: {
            access_token: localStorage.getItem("access_token")
          },
          params: {
            startDate: this.startDate,
            endDate: this.endDate,
            page: this.currentPage,
            limit: this.perPage,
            keyword : this.keyword,
            HomeId : this.findHomeId,
            type : this.findType,
          }
        })
        console.log(data);
        this.voucers = data.data2.result
        let totalPage = Math.ceil(data.data2.dataLength / this.perPage)
				this.totalPage = totalPage
        this.isLoading = false
        this.totalBalance = data.totalBalance
      } catch(err) {
        this.isLoading = false
        console.log(err);
      }

    },

    async getHome() {
      this.isLoading = true
      try {
        
        let {data} = await axios({
          method: "GET",
          url: "/home",
          headers: {
            access_token: localStorage.getItem("access_token")
          },
          params: {
            page: this.currentPage,
            limit: this.perPage,
            keyword: this.keyword,
          }
        })
        this.homes = data
        // let totalPage = Math.ceil(data.data2.dataLength / this.perPage)
				// this.totalPage = totalPage
        this.isLoading = false
      } catch(err) {
        this.isLoading = false
        console.log(err);
      }

    },

    async printCsv() {
      this.isLoading = true
      try {
        
        let {data} = await axios({
          method: "GET",
          url: "/transaksi/print",
          headers: {
            access_token: localStorage.getItem("access_token")
          },
          params: {
            startDate: this.startDate,
            keyword: this.keyword,
            BranchId: this.findBranchId,
            type: this.findType, 
            status: this.findStatus, 
          }
        })
        const dataToConvert = {
          data: data,
          filename: 'Voucer',
          delimiter: ',',
        }
        csvDownload(dataToConvert)
        this.isLoading= false
      } catch(err) {
        this.isLoading = false
        console.log(err);
      }

    },

    async addVoucer() {

      try {
        let status = null
        if(this.type == 2) {
          status = this.status
        }

        let amount = this.amount.trim().split('.').filter(e => e != '.' ).join('')
        let data =  {
          date:  this.date,
          type:  this.type,
          notes:  this.notes,
          secondMak: this.secondMak,
          HomeId: this.HomeId,
          amount:  amount,
        }

        let data2 = await axios({
          method: "POST",
          url: "/transaksi",
          data: data,
          headers: {
            access_token: localStorage.getItem("access_token")
          },
        })
        $('#mainModal').modal('hide')
        // this.date=  ""
        // this.type=  ""
        // this.notes=  ""
        // this.amount=  0
        Swal.fire('Berhasil', 'Data Berhasil Ditambahkan', 'success');
        this.getVoucer()
      } catch(err) {
        console.log(err);
        Swal.fire('Maaf', 'Periksa Kembali data anda', 'error');
      }
    },

    async editVoucer() {

      try {
        
        let payload =  {
          BranchId:  this.BranchId,
          date:  this.date,
          status:  this.status,
          type:  this.type,
          notes:  this.notes,
          amount:  this.amount.trim().split('.').filter(e => e != '.' ).join(''),
          isOpen : false
        }

        let data2 = await axios({
          method: "put",
          url: `/transaksi/${this.id}`,
          data: payload,
          headers: {
            access_token: localStorage.getItem("access_token")
          },
        })
        $('#mainModal').modal('hide')
        this.getVoucer()
        this.BranchId=  0
        this.date=  ""
        this.status=  ""
        this.type=  ""
        this.notes=  ""
        this.OrderId=  ""
        this.amount=  0
        this.id=  0
        Swal.fire('Berhasil', 'Data Berhasil Ditambahkan', 'success');
        
      } catch(err) {
        console.log(err);
        Swal.fire('Maaf', 'Periksa Kembali data anda', 'error');
      }
    }, 

    async deleteData(id) {
      
      try {
        
        let data = await axios.delete(`/transaksi/${id}`, {
          headers: {
            access_token: localStorage.getItem("access_token")
          },
        })
        Swal.fire('Berhasil', 'Data Berhasil Dihapuskan', 'success');
        this.getVoucer()

      } catch(err) {
        Swal.fire('Maaf', 'Periksa Kembali data anda', 'error');

      } 
    },
    async confirmDelete(id) {
      
      try {
        let data = await Swal.fire({
            title: 'Yakin?',
            text: 'Apakah Yakin ',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Hapus!!',
        })
        if (data.isConfirmed) {
            this.deleteData(id);
            this.getVoucer()
        } else {
                Swal.fire('Ok', 'Proses anda berhasil dibatalkan', 'error');
              }
              
              
            } catch(err) {
              
              Swal.fire('Maaf', 'Proses anda berhasil dibatalkan', 'error');
      }
    },
    cekMak(id) {
      return this.maks.find(e => e.id == id).name
    },
    cekHome(id) {
      let name = ''
      if(+id) return this.homes.find(e => e.id == id).name
      return name
    },
    addPage() {
      this.currentPage = this.currentPage + 1
      this.getVoucer()
    },
    minPage() {
      this.currentPage = this.currentPage - 1
      this.getVoucer()
    },
  }
}
</script>

<style scoped>
  .cardRow {
    /* display: flex; */
    width: 100%;
    /* background-color: aqua; */
  }

.centered-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

#mainModal {
  
  align-items: center;

}






</style>